<template>
 <div>
    <h1 class="mb-8 font-bold text-3xl">Reportes entre Fechas</h1>
      <!--
        <input v-model="form.finicio" class="border py-2 px-3 text-grey-800" type="date" required label="Fecha Inicio">
        <input v-model="form.ffin" class="border py-2 px-3 text-grey-800" type="date" required label="Fecha Fin">
        <select-input v-model="form.contact_id" :error="form.errors.contact_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Empresa">
             <option value="todos">Todos</option>
            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">{{ contact.nombres }} {{ contact.apellidos}}</option>
          </select-input>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Buscar</loading-button>
        </div>
     -->
     <input v-model="finicio" class="border py-2 px-3 text-grey-800" type="date" required label="Fecha Inicio">
        <input v-model="ffin" class="border py-2 px-3 text-grey-800" type="date" required label="Fecha Fin">
      
       <select-input v-model="contact_id" :error="form.errors.contact_id" class="pr-6 pb-8 w-full lg:w-1/2" label="Empresa">
             <option value="todos">Todos</option>
            <option v-for="contact in contacts" :key="contact.id" :value="contact.id">{{ contact.nombres }} {{ contact.apellidos}}</option>
          </select-input>
     <button class="btn btn-danger" type="submit" 
        @click="saludar">Cancelar</button>
 </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import Pagination from '@/Shared/Pagination'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'


export default {
  metaInfo: { title: 'Reports' },
   components: {
    Icon,
    Pagination,
    LoadingButton,
    SelectInput,
  },
  layout: Layout,
   props: {
    contacts: Array,
  },
  methods: {
      saludar: function (event) {
        alert("asdas");

        window.location.href = window.location.origin +'/diariosR'

     // this.form.get(this.route('diarios.reporte'))
    },
  },
  
}
</script>
